/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  font-size: calc(14rem/14);
  line-height: calc(20rem/14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host label {
  font-weight: 600;
}

:host([hidden]) {
  display: none;
}`;
export { style };
